import React from 'react'
import "./Footer.css"
import shape from "../../Assets/Home/shape-bg.png"
export default function Footer() {
  return (
    <div className='footer-container'>
        <div className='footer-parent'>
            <img src = {shape}/>
        </div>
    </div>
  )
}
